import { render } from "./ShopModule.vue?vue&type=template&id=cb802446"
import script from "./ShopModule.vue?vue&type=script&lang=ts"
export * from "./ShopModule.vue?vue&type=script&lang=ts"

import "../../assets/scss/modules/shop.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script